var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Styled } from './style';
var LogsTable = /** @class */ (function (_super) {
    __extends(LogsTable, _super);
    function LogsTable(props) {
        return _super.call(this, props) || this;
    }
    LogsTable.prototype.render = function () {
        var logsList = this.props.logsData.map(function (log, idx) { return (React.createElement(Styled, { key: "logs-list-" + idx },
            React.createElement("div", { className: "log-list-item-title" },
                React.createElement("span", { className: "log-list-item-bold" }, log.sectionName),
                " ",
                log.action,
                " ",
                log.message,
                ' ',
                React.createElement("span", { className: "log-list-item-bold" }, log.content),
                " ",
                log.type),
            React.createElement("div", { className: "log-list-item-desc" },
                log.username,
                ",",
                new Date(log.timestamp).toString(),
                ' '))); });
        return (React.createElement(React.Fragment, null, logsList || (React.createElement(FormattedMessage, { id: "ui_component.logs_table.no_logs_data_available", defaultMessage: "No Logs data available" }))));
    };
    return LogsTable;
}(React.Component));
var StyledLogs = styled(LogsTable)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
Object.assign(StyledLogs, {
    displayName: 'LogsTable',
});
export default StyledLogs;
var templateObject_1;
//# sourceMappingURL=index.js.map